<template>
  <div class="container">
    <a-form :form="form" @submit.prevent="handleSubmit" autocomplete="off">

      <!-- Contacts Card -->
      <div class="flex flex-col md:flex-row">
        <div class="w-full md:w-1/6">
          <h4 class="text-gray-900 text-lg">Contacts</h4>
        </div>
        <div class="w-full md:w-5/6">
          <vs-card class="p-5">
            <div class="flex flex-col-reverse md:flex-row md:justify-between">

              <div class="self-center profile-mobile">
                <p class="my-5 text-sm font-medium">
                  Which Type of Contact do you want to create?
                </p>
                <a-radio-group v-model="radioType" @change="handleRadio" :default-value="1">
                  <a-radio :value="1">Person</a-radio>
                  <a-radio :value="2">Company</a-radio>
                </a-radio-group>
              </div>

              <div class="mt-3 flex flex-col self-center">
                <Xupload class="profile-photo" url="/storage/public/" ref="contact" :rows="rows" @input="profileUser"/>
                <p class="font-bold text-base profile">Profile Photo</p>
              </div>

            </div>
          </vs-card>
        </div>
      </div>

      <!-- Contact Information -->
      <a-divider />
      <div class="flex flex-col md:flex-row">
        <div class="w-full md:w-1/6">
          <h4 class="text-gray-900 text-lg">Contact Information</h4>
        </div>
        <div class="w-full md:w-5/6">
          <vs-card class="p-5">
            <div class="grid sm:grid-cols-1 md:grid-cols-2 gap-x-4">
              <template v-if="radioType === 1">
                <a-auto-complete>
                  <a-form-item label="First Name" has-feedback>
                    <a-input
                      v-decorator="['person.first_name',{ rules: [{ required: true, message: 'Please input your First name!' }] }]"
                      placeholder="First Name"
                      autocomplete="none"
                    />
                  </a-form-item>
                </a-auto-complete>
                <a-form-item label="Last Name" has-feedback>
                    <a-input
                      autocomplete="none"
                      v-decorator="['person.last_name',{ rules: [{ required: true, message: 'Please input your Last name!' }] }]"
                      placeholder="Last Name"
                    />
                </a-form-item>
                <a-form-item label="Middle Name" has-feedback>
                  <a-input
                    v-decorator="['person.middle_name',{ initialValue:null,rules: [{ required: false }] }]"
                    placeholder="Middle Name"
                    autocomplete="none"
                  />
                </a-form-item>
                <a-form-item label="Prefix" has-feedback>
                  <a-input
                    v-decorator="['person.prefix',{ initialValue:null,rules: [{ required: false }] }]"
                    placeholder="prefix"
                    autocomplete="none"
                  />
                </a-form-item>
                <a-form-item label="Birth Date" has-feedback>
                  <a-date-picker
                    v-decorator="['person.birth_day',{ initialValue:null,rules: [{ required: false }] }]"
                    placeholder="birthDay"
                    autocomplete="none"
                    valueFormat="YYYY-MM-DD"
                    :format="dateFormat"
                  />
                </a-form-item>
              </template>
              <template v-else>
                <a-form-item label="Company" has-feedback>
                  <a-input
                    v-decorator="['company.name',{ initialValue:null,rules: [{ required: true, message: 'Please input your company' }] }]"
                    placeholder="company"
                    autocomplete="none"
                  />
                </a-form-item>
              </template>

              <!-- EMAIL FIELD -->
              <div class="flex flex-col">
                <transition-group name="slide" mode="out-in">
                  <div v-for="(email,index) in emails" :key="index">
                    <feather-icon
                      icon="MinusCircleIcon"
                      @click="()=>removeItem(index,emails,email.id,item_delete_contact_email,'emails')"
                      svg-classes="text-primary"
                      v-if="index !== 0"
                      class="pt-4 cursor-pointer minus"/>
                    <a-form-item v-show="false">
                      <a-input
                        v-decorator="[`emails[${index}].id`,{ initialValue:null,rules: [{ required: false }]}]"
                      />
                    </a-form-item>
                    <a-form-item :label="index === 0 ? 'Email' : '' " class="email" has-feedback>
                      <a-input
                        autocomplete="none"
                        v-decorator="[`emails[${index}].email_address`,{initialValue: null , rules: [{ required:false,message: 'Please input your Email address!' },{ pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, required: false,message: 'format email is invalid.' }] }]"
                        placeholder="example@gmail.com"
                        class="w-full"
                      >
                        <template #addonAfter>
                          <a-form-item>
                            <a-select
                              v-decorator="[`emails[${index}].email_type`,{initialValue: 0 , rules: [{ required: true, message: 'Please input your type email!' }] }]"
                              placeholder="Type"
                              show-search
                              :filter-option="filterOption"
                              style="width: 90px;"
                            >
                              <!-- allowClear -->
                              <a-select-option :value="0">Work</a-select-option>
                              <a-select-option :value="1">Person</a-select-option>
                              <a-select-option :value="2">Other</a-select-option>
                            </a-select>
                          </a-form-item>
                        </template>
                      </a-input>
                    </a-form-item>
                  </div>
                </transition-group>

                <a-tooltip placement="rightTop" v-if="emails.length < 5">
                  <template slot="title">
                    <span>Add Email</span>
                  </template>
                  <a-button type="primary" shape="circle" icon="plus" class="plus-icon self-start" @click="addEmail(emails)"/>
                </a-tooltip>

              </div> <!-- END EMAIL FIELD -->

              <!-- WEBSITE FIELD -->
              <div class="flex flex-col">
                <transition-group name="slide" mode="out-in">
                  <div v-for="(site,index) in sites" :key="index">
                    <feather-icon
                      icon="MinusCircleIcon"
                      @click="()=>removeItem(index,sites,site.id,item_delete_contact_website,'websites')"
                      svg-classes="text-primary"
                      v-if="index != 0"
                      class="pt-4 cursor-pointer minus minus-website"/>
                    <a-form-item v-show="false">
                      <a-input
                        v-decorator="[`websites[${index}].id`,{ initialValue:null,rules: [{ required: false }]}]"
                      />
                    </a-form-item>
                    <a-form-item :label="index === 0 ? 'Website' : ''" :class="sites.length > 1 ? 'site' : '' " has-feedback>
                      <a-input autocomplete="none" class="website" placeholder="example.com" v-decorator="
                          [`websites[${index}].website_address`,
                            {
                              initialValue:null,
                              rules: [
                                {
                                    required: false,
                                    message: 'Please input your website'
                                },
                                {
                                    pattern:/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                    type: 'string',
                                    message:'format website is invalid.',
                                    required: false
                                }
                            ]
                           }
                      ]" style="border-radius: 3px !important;">
                        <template #addonAfter>
                          <a-form-item class="!mb-0">
                            <a-select
                              v-decorator="[`websites[${index}].website_type`,{initialValue: 0 , rules: [{ required: true, message: 'Please input your type website!' }] }]"
                              placeholder="Type"
                              class="country"
                              show-search
                              :filter-option="filterOption"
                              style="min-width: 100px;"
                            >
                              <!-- allowClear -->
                              <a-select-option :value="0">Work</a-select-option>
                              <a-select-option :value="1">Personal</a-select-option>
                              <a-select-option :value="2">FaceBook</a-select-option>
                              <a-select-option :value="3">Linkedin</a-select-option>
                              <a-select-option :value="4">Twitter</a-select-option>
                              <a-select-option :value="5">Instant messenger</a-select-option>
                              <a-select-option :value="6">Other</a-select-option>
                            </a-select>
                          </a-form-item>
                        </template>
                      </a-input>
                    </a-form-item>
                  </div>
                </transition-group>
                <a-tooltip placement="leftTop" v-if="sites.length < 5">
                  <template slot="title">
                    <span>Add Website</span>
                  </template>
                  <a-button type="primary" shape="circle" icon="plus" class="plus-icon self-start" @click="addWebsite(sites)"/>
                </a-tooltip>
              </div> <!-- END WEBSITE FIELD -->

              <!-- PHONE NUMBER FIELD -->
              <div class="flex flex-col">
                <transition-group name="slide" mode="out-in">
                  <div v-for="(phone,index) in phonies" :key="index" >
                    <feather-icon
                      icon="MinusCircleIcon"
                      @click="()=>removeItem(index,phonies,phone.id,item_delete_contact_phone,'phones')"
                      svg-classes="text-primary"
                      v-if="index !== 0"
                      class="pt-4 cursor-pointer minus"/>
                    <a-form-item v-show="false">
                      <a-input
                        v-decorator="[`phones[${index}].id`,{ initialValue:null,rules: [{ required: false }]}]"
                      />
                    </a-form-item>
                    <a-form-item :label="index === 0 ? 'Phone Number' : ''" has-feedback>
                      <a-input
                        autocomplete="none"
                        class="phonies"
                        v-decorator="[`phones[${index}].phone_number`,
                                {
                                  initialValue:null,
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input your Phone number!'
                                    },
                                    {
                                      pattern: /^\+?\d*$/,
                                      type:'string',
                                      message: 'Phone number only contain numbers.',
                                      required:false,
                                    }
                                ],
                               },
                        ]"
                        placeholder="Phone Number"
                      >
                        <template #addonAfter>
                          <a-form-item>
                            <a-select
                              v-decorator="[`phones[${index}].phone_type`,{initialValue: 0 , rules: [{ required: true, message: 'Please input your type phone!' }] }]"
                              placeholder="Type"
                              show-search
                              :filter-option="filterOption"
                              style="width: 80px;"
                            >
                              <!-- allowClear -->
                              <a-select-option :value="0">Work</a-select-option>
                              <a-select-option :value="1">Home</a-select-option>
                              <a-select-option :value="2">Mobile</a-select-option>
                              <a-select-option :value="3">Pager</a-select-option>
                              <a-select-option :value="4">Skype</a-select-option>
                              <a-select-option :value="5">Other</a-select-option>
                            </a-select>
                          </a-form-item>
                        </template>

                      </a-input>
                    </a-form-item>
                  </div>
                </transition-group>
                <a-tooltip placement="rightTop" v-if="phonies.length < 5">
                  <template slot="title">
                    <span>Add PhoneNumber</span>
                  </template>
                  <a-button type="primary" shape="circle" icon="plus" class="plus-icon self-start" @click="addPhoneNumber(phonies)"/>
                </a-tooltip>
              </div> <!-- END PHONE NUMBER FIELD -->
            </div>
          </vs-card>
        </div>
      </div>

      <!-- ADDRESS SECTION -->
      <a-divider />
      <section class="flex flex-col md:flex-row scoll_bottom">
        <!-- TITLE -->
        <div class="w-full md:w-1/6">
          <h4 class="text-gray-900 text-lg">Address</h4>
        </div>

        <!-- BODY -->
        <div class="w-full md:w-5/6">
          <vs-card class="p-5 scrollBottom">
            <transition-group name="slide" mode="out-in">
              <div v-for="(address,index) in addresses" :key="index">
                <feather-icon
                  icon="MinusCircleIcon"
                  @click="()=>removeItem(index,addresses,address.id,item_delete_contact_address,'addresses')"
                  svg-classes="text-primary"
                  v-if="index != 0"
                  class="cursor-pointer minus-address"/>
                <a-form-item v-show="false">
                  <a-input
                    v-decorator="[`addresses[${index}].id`,{ initialValue:null,rules: [{ required: false }]}]"
                  />
                </a-form-item>

                <!-- ADDRESS -->
                <a-form-item label="Address" has-feedback>
                  <a-textarea
                    v-decorator="[`addresses[${index}].street`,{ initialValue:null,rules: [{ required: false },{ required: false, max: 120, message: 'The number of characters must be less than 120' }] }]"
                    autocomplete="none"
                  />
                </a-form-item>
                <!--<a-form-item v-show="false">-->
                <!-- <input v-decorator="[`addresses[${index}].address_type`,{ initialValue:0,rules: [{ required: false }]}]"/>-->
                <!--</a-form-item>-->

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- CITY -->
                  <a-form-item label="City" has-feedback>
                    <a-input
                      v-decorator="[`addresses[${index}].city`,{initialValue:null,rules: [{ required: false }] }]"
                      placeholder="City"
                      autocomplete="none"
                    />
                  </a-form-item>

                  <!-- STATE -->
                  <a-form-item label="State" has-feedback>
                    <a-input
                      v-decorator="[`addresses[${index}].state`,{ initialValue:null,rules: [{ required: false }] }]"
                      autocomplete="none"
                    />
                  </a-form-item>

                  <!-- COUNTRY -->
                  <a-form-item label="Country" has-feedback>
                    <a-select
                      v-decorator="[`addresses[${index}].country`,{ initialValue:null,rules: [{ required: false }] }]"
                      placeholder="Country"
                      class="country"
                      allowClear
                      show-search
                      autocomplete="none"
                      :filter-option="filterOption"
                    >
                      <a-icon slot="suffixIcon" type="search" />
                      <a-select-option v-for="city in cities" :value="city.id">
                        {{ city.name }} ({{ city.code }})
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <!-- Postcode -->
                  <a-form-item label="Postcode" has-feedback>
                    <a-input
                      v-decorator="[`addresses[${index}].post_code`,
                      {
                        initialValue:null,rules: [{ required: false }],
                      },
                    ]"
                      autocomplete="none"
                      class="number_phone"
                    />
                  </a-form-item>
                </div>
                <a-divider v-if="index != addresses.length - 1"/>
              </div>
            </transition-group>
            <a-tooltip placement="rightTop" v-if="addresses.length < 5">
              <template slot="title">
                <span>Add Address</span>
              </template>
              <a-button type="primary" shape="circle" icon="plus" class="plus-icon" @click="addAddress(addresses)"/>
            </a-tooltip>
          </vs-card>
        </div>
      </section>

      <!-- E-Invoicing Information -->
      <a-divider/>
      <div class="flex flex-col md:flex-row">
        <div class="w-full md:w-1/6">
          <h4 class="text-gray-900 text-lg">E-Invoicing Information</h4>
        </div>
        <div class="w-full md:w-5/6">
          <vs-card class="p-5">
            <div class="grid sm:grid-cols-1 md:grid-cols-2 gap-x-4">
              <template v-if="radioType === CONTACT_TYPE_PERSON">
                <a-form-item label="BRN" has-feedback>
                  <a-input
                    v-decorator="['person.brn']"
                    placeholder="Business Registration Number"
                  />
                </a-form-item>
                <a-form-item label="SST Registration Number" has-feedback>
                  <a-input
                    v-decorator="['person.sst_registeration_number']"
                    placeholder="SST Registration Number"
                  />
                </a-form-item>
                <a-form-item label="TIN" has-feedback>
                  <a-input
                    v-decorator="['person.tin']"
                    placeholder="Tax Identification Number"
                  />
                </a-form-item>
              </template>

              <template v-else-if="radioType === CONTACT_TYPE_COMPANY">
                <a-form-item label="BRN" has-feedback>
                  <a-input
                    v-decorator="['company.brn']"
                    placeholder="Business Registration Number"
                  />
                </a-form-item>
                <a-form-item label="SST Registration Number" has-feedback>
                  <a-input
                    v-decorator="['company.sst_registeration_number']"
                    placeholder="SST Registration Number"
                  />
                </a-form-item>
                <a-form-item label="TIN" has-feedback>
                  <a-input
                    v-decorator="['company.tin']"
                    placeholder="Tax Identification Number"
                  />
                </a-form-item>
              </template>

            </div>
          </vs-card>
        </div>
      </div>

      <br>
      <br>
      <br>

      <Footer v-if="hasPermission('contact.edit')" class="contact-footer" url="/contacts"/>

    </a-form>
  </div>
</template>

<script>

import Xupload from '../../components/x-upload/XUpload'
import axios from '@/axios'
import Mixin from '../mixin/mixin'
import Footer from "@/views/footer/Footer";
import moment from 'moment'

export default {
  name: "ContactAdd",

  mixins: [Mixin],

  components: {
    Xupload,
    Footer
  },

  data() {
    return {
      // CONSTANTS
      CONTACT_TYPE_PERSON: 1,
      CONTACT_TYPE_COMPANY: 2,
      
      imageUrl: '',
      loading: false,
      cities:[],
      emails:[{id:null,email_address:null,email_type: 0}],
      sites:[{id:null,website_address:null,website_type: 0}],
      addresses:[{id:null,country:null,city: null,state:null,street:null,post_code:null,address_type:0}],
      temp:2,
      rows:{},
      phonies:[{id:null,phone_number:null,phone_type: 0}],
      item_delete_contact_email:[],
      item_delete_contact_website:[],
      item_delete_contact_phone:[],
      item_delete_contact_address:[],
      st:null,
      profileSrc: null,
      fetching:false,
      radioType: 1
    }
  },

  methods:{
    handleRadio(e){
      this.radioType = e.target.value
    },

    handleSubmit() {
      this.form.validateFields(async(err, values) => {
        if(this.radioType === 1){
          if(!values.person.first_name){
            this.$message.error('Filling in the First Name is required.')
            window.scroll({ top: 0, behavior: 'smooth' });
            return
          }
          if(!values.person.last_name){
            this.$message.error('Filling in the Last Name is required.');
            window.scroll({ top: 0, behavior: 'smooth' });
            return
          }
        }else {
          if(!values.company.name){
            this.$message.error('Filling in the Company is required.');
            window.scroll({ top: 0, behavior: 'smooth' });
            return
          }
        }
        if (!err) {
          try{
            this.$vs.loading()
            this.profileSrc ? values.avatar_url = this.profileSrc : values.avatar_url = this.rows ? this.rows.avatar_url : null

            if((values.emails[0].email_address==null || values.emails[0].email_address=="")  && values.emails.length == 1){
              values.emails = []
            }
            if((values.phones[0].phone_number==null || values.phones[0].phone_number=="")  && values.phones.length == 1){
              values.phones = []
            }
            if((values.websites[0].website_address==null || values.websites[0].website_address=="") && values.websites.length == 1){
              values.websites = []
            }
            if(!values.addresses[0].country && !values.addresses[0].city && !values.addresses[0].state && !values.addresses[0].post_code && !values.addresses[0].street && values.addresses.length == 1){
              values.addresses = []
            }
            if(this.editContact && this.rows){
              if ((values.person && values.person.birth_day))
                values.person.birth_day = moment(values.person.birth_day).format('YYYY-MM-DD')
              await axios.put(`contact/${this.$route.params.id}/`, values)
            }else{
              await axios.post('contact/', values)
            }
            this.$notification['success']({
              message: 'Success',
              description: `Contact ${this.editContact ? 'updated' : 'created'}.`
            })
            await this.$router.push('/contacts')
            this.form.resetFields()
          }catch (e) {
            this.$notification['error']({
              message: 'Failed',
              description: `Server error`
            })
          }finally {
            this.$vs.loading.close()
          }

        }
      });
    },

    async getCity(){
      const { data } = await axios.post('/dictionary/country/')
      this.cities = data
    },

    async editItem(){
      try{
        this.$vs.loading()
        const { data } = await axios.get(`/contact/${this.$route.params.id}/?random=${this.getRandomDigitsWords(20)}`)
        this.rows = data
        this.radioType = data.contact_type
        if(data.avatar_url){
          this.$refs.contact.imageUrl = data.avatar_url
        }
        data.emails.length    == 0  ?  this.emails = [{id:null,email_address:null,email_type: 0}] : this.emails = data.emails;
        data.websites.length  == 0  ?  this.sites = [{id:null,website_address:null,website_type: 0}] : this.sites = data.websites
        data.phones.length    == 0  ?  this.phonies = [{id:null,phone_number:null,phone_type: 0}] : this.phonies = data.phones
        data.addresses.length == 0  ?  this.addresses = [{id:null,country:null,city: null,state:null,street:null,post_code:null,address_type:0}] : this.addresses = data.addresses
        this.$nextTick(()=>{
          this.form.setFieldsValue(data)
        })
      }catch (e) {
        this.$ntSetError()
      }finally {
        this.$vs.loading.close()
      }
    },

    addEmail(emails){
      emails.push({id:null,email_address:null,email_type: 0});
    },

    addWebsite(sites){
      sites.push({id:null,website_address:null,website_type: 0});
    },

    addPhoneNumber(phonies){
      phonies.push({id:null,phone_number:null,phone_type: 0});
    },

    addAddress(address){
      address.push({id:null,country:null,city: null,state:null,street:null,post_code:null,address_type:0});
    },

    async removeItem(index,emails,email,array_delete,item_delete){
      const keys = this.form.getFieldValue(item_delete);
      if(this.editContact && email){
        this.form.setFieldsValue({
          [item_delete]: keys.filter(item => item.id !== email),
        });
        const find_id_remove = emails.find(item=>item.id == email)
        array_delete.push(find_id_remove.id)
        await axios.post(`contact/${this.$route.params.id}/delete/`, {
          [item_delete]: array_delete
        })
      }else{
        this.form.setFieldsValue({
          [item_delete]: keys.filter((item,i) => i !== index),
        });
      }
      emails.splice(index,1)
    },

    profileUser(src){
      this.profileSrc = src
    }

  },
  computed: {
    editContact() {
      return this.$route.params && this.$route.params.id !== undefined
    }
  },
  mounted() {
    this.getCity()
    if(this.editContact){
      this.editItem()
    }
  },
  created() {
    if(this.$route.query.type) {
      if(this.$route.query.type === 'person' || this.$route.query.type === 'company')
        this.$route.query.type === "person" ? this.radioType = 1 : this.radioType = 2
      else
        this.$router.push({ path: '/contacts/add', query: { type: 'person' }})
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }

}
</script>

<style>
@import "../style/style.css";

.container{
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

[dir] .ant-divider{
  /*background: #ccc !important;*/
}

[dir] .ant-input{
  border-radius: 3px !important;
}

.profile{
  margin-bottom: 0 !important;
}

.number_phone .ant-input{
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.number_phone .ant-input-group-addon{
  border-radius: 3px;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.website {
  /*margin-bottom: 4px !important;*/
}

.website .ant-input-group-addon{
  border-radius: 3px;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.website .ant-input , .phonies .ant-input , .email .ant-input{
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.website_domain .ant-select-selection.ant-select-selection--single{
  border-top-right-radius: 3px !important;
  border-bottom-right-radius: 3px !important;
}

.country .ant-select-selection.ant-select-selection--single{
  border-radius: 3px !important;
}

.minus{
  padding-top: 1em;
  text-align: right;
  width: 25px;
  display: block;
  margin-left: auto;
}

.feather-minus-circle:hover{
  color:#ff2424 !important;
}

.minus{
  cursor: pointer;
  transition: 0.5s cubic-bezier(0.71, 0.63, 0, 1.29);
  transform: translateY(0);
}

.plus-icon,.minus-address{
  margin-bottom: 1em;
  cursor: pointer;
  transition: 0.5s cubic-bezier(0.71, 0.63, 0, 1.29);
  transform: translateY(0);
}

.plus-icon:hover,.minus:hover,.minus-address:hover{
  transition: 0.5s cubic-bezier(0.71, 0.63, 0, 1.29);
  transform: translateY(-3px);
}

.slide-enter-active {
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -webkit-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.email .ant-form-explain,.site .ant-form-explain , .phone .ant-form-explain{
  position: absolute;
  /*bottom: 20px;*/
}

.vs-card--content,.con-vs-card{
  margin-bottom: 0 !important;
}

.minus-address{
  /*margin-bottom: 2em;*/
  text-align: end;
  display: block;
}

.ant-message{
  z-index: 1000000000000;
}

.minus-website{
  margin-left: auto;
  display: block;
  text-align: end;
}

[dir] .ant-upload.ant-upload-select-picture-card{
  /*border-radius: 50% !important;*/
}

.profile-photo .ant-upload.ant-upload-select-picture-card > .ant-upload{
  display: flex;
  justify-content: center;
  align-items: center;
}

.has-success.has-feedback .ant-form-item-children-icon {
  /*color: #3A3DBE !important;*/
  /*z-index: 0;*/
}


.slide-up-enter-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-up-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);

}
.slide-up-enter, .slide-fade-leave-to {
  transform: translateY(10vh);
  opacity: 0;
}

.slide-up-enter-to, .slide-up-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-up-enter, .slide-up-leave-to {
  overflow: hidden;
  max-height: 0;
}

[dir=ltr] .ant-btn.ant-btn-primary{
 margin-right: 0 !important;
}

[dir=ltr] form .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value {
  padding-right: 20px !important;
}

/* Fix Ant dropdown to small when cleared */
</style>
